import { useEffect } from 'react';
import {
  TableAdapter,
  TableAdapterHook,
  TableAdapterStatus,
  TableState,
} from 'src/components/DataTable/types/DataTable';
import { IErrorResponse } from 'src/utilities/shared-types';
import { SdkErrorResponse } from 'src/utilities/notifications';
import { hasActiveFilters } from 'src/components/DataTable/components/DataTableProvider/hooks/useTableAdapter.utils';

export interface UseTableAdapterReturn<TData, TFilters> {
  data: TData[];
  total: number;
  status: TableAdapterStatus;
  error?: IErrorResponse | SdkErrorResponse;
  isLoading: boolean;
  isEmpty: boolean;
  isError: boolean;
  hasFilters: boolean;
  fetch: TableAdapter<TData, TFilters>['fetch'];
}

export function useTableAdapter<TData, TFilters>(
  adapter: TableAdapterHook<TData, TFilters>,
  tableState: TableState<TFilters>
): UseTableAdapterReturn<TData, TFilters> {
  const { data, total, status, error, fetch } = adapter(tableState);

  useEffect(() => {
    fetch(tableState);
  }, [fetch, tableState]);

  const isLoading = status === TableAdapterStatus.LOADING;
  const isEmpty = data.length === 0;
  const isError = status === TableAdapterStatus.ERROR;
  const hasFilters = hasActiveFilters(tableState);

  return {
    data,
    total,
    status,
    error,
    isLoading,
    isEmpty,
    isError,
    hasFilters,
    fetch,
  };
}
